import { render, staticRenderFns } from "./numberServe.vue?vue&type=template&id=3c2444bc&scoped=true"
import script from "./numberServe.vue?vue&type=script&lang=js"
export * from "./numberServe.vue?vue&type=script&lang=js"
import style0 from "./numberServe.vue?vue&type=style&index=0&id=3c2444bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2444bc",
  null
  
)

export default component.exports